import { atom } from "jotai";

export const terrainFilterAtom = atom<string | null>(null);
export const paceFilterAtom = atom<string | null>(null);
